document.addEventListener('click', function (e) {
  const button = e.target.closest('.video__button');
  if (!button) return;

  const frame = button.closest('.video__frame');
  const video = frame.querySelector('.video__asset');

  frame.classList.add('video__playing');

  // Remove button entirely (cleanest)
  button.remove();

  // Uploaded video
  if (video.tagName === 'VIDEO') {
    video.play();
  }
  // Embedded video
  else if (video.tagName === 'IFRAME') {
    autoplayEmbed(video);
  }
});

function autoplayEmbed(iframe) {
  const src = iframe.getAttribute('src');
  const separator = src.includes('?') ? '&' : '?';
  iframe.src = src + separator + 'autoplay=1';
}
